import ReactTooltip from 'react-tooltip';

import { Sidebar } from '../../../../shared/components';
import { SidebarLayout } from '../../../../shared/layout';
import { CreateFolder, FoldersTree } from '../../folders/components';
import { useFolderTree } from '../../folders/context';
import { ResourceLinks } from './resource-links.component';

export const ResourcesSidebarLayout: React.FC = ({ children }) => {
  const {
    refetch,
    canCreateMainFolder,
    selectedFolder,
    selectedFolderPath,
    handleSelectFolder,
  } = useFolderTree();

  return (
    <>
      <SidebarLayout
        sidebar={
          <Sidebar
            heading="Documents"
            filterLinks={<ResourceLinks />}
            action={
              canCreateMainFolder && (
                <CreateFolder
                  onSuccess={refetch}
                  modalHeading="New Main Folder"
                  text="Create main folder"
                  className="w-full"
                />
              )
            }
          >
            <FoldersTree
              selectedFolder={selectedFolder}
              selectedFolderPath={selectedFolderPath}
              onSelect={handleSelectFolder}
            />
          </Sidebar>
        }
      >
        {children}
      </SidebarLayout>

      <ReactTooltip arrowColor="rgba(1,1,1,0)" place="bottom" effect="solid" />
    </>
  );
};
